import {ref} from 'vue';

export default {
    install: (app, options) => {
        const payment = ref(null);
        const paymentInvoice = ref(null);
        const paymentTokens = ref(0);

        const getPaymentByCheckoutSessionId = (checkout_session_id) => {
            window.lazy_axios.get(`/dashboard/payments/${checkout_session_id}`)
                .then((response) => {
                    payment.value = response.data.payment;
                    paymentInvoice.value = response.data.invoice;
                    paymentTokens.value = response.data.tokens;
                });
        };

        app.provide('payment', payment);
        app.provide('paymentInvoice', paymentInvoice);
        app.provide('paymentTokens', paymentTokens);
        app.provide('getPaymentByCheckoutSessionId', getPaymentByCheckoutSessionId);
    },
}
